import {IApiBusinessProfileProto, UpdatedProfileResponse} from "../../provider_api";
import React from "react";
import {KensuObjectEditor} from "./KensuObjectEditor";
import {useProviderProfile} from "../../ProviderProfileProvider";

type Props<T> = {

  // If set, this is editing and existing id (this one!)
  idParam: string | undefined;

  // Load this T things from the profile.
  getFromProfile: (profile: IApiBusinessProfileProto, id: string | null | undefined) => T | null | undefined;

  // Typically this object editor shows the object's name (Location X, Package Y) and a back
  // button when in edit mode. But the business profile is a singleton, and we don't want to
  // show the header at all. 
  hideHeaderInEditMode?: boolean

  // Used for the page title when editing the thing.
  getTitle: (entity: T) => string | null | undefined;

  // like "Service"
  entityName: string;
  entityNamePlural?: string;
  entityListViewLink: string; // like /catalog/services

  newBlankType: () => T;

  children: React.ReactNode;

  getRpcMethod: (isUpdate: boolean) => string,
  getRpcPayload: (workingCopy: T) => Uint8Array,

  // IF this entity is archivable, set this field name. An "archive" option will
  // show up in the editor.
  archiveField?: keyof T,
}

/**
 * A specialization of KensuObjectEditor that handles updates specifically to
 * the business profile, it loads the profile from the context, calls an RPC
 * specified by the client, and then handles a parsed UpdatedProfileResponse.
 *
 */
export const KensuProfileEditor = <T extends object>(props: Props<T>) => {

  const {businessProfile, setBusinessProfile} = useProviderProfile();

  return <KensuObjectEditor<T, IApiBusinessProfileProto>
      children={props.children}
      idParam={props.idParam}
      entityName={props.entityName}
      entityNamePlural={props.entityNamePlural}
      hideHeaderInEditMode={props.hideHeaderInEditMode}
      entityListViewLink={props.entityListViewLink}
      getter={id => businessProfile && props.getFromProfile(businessProfile, id)}
      getTitle={props.getTitle}
      newBlankType={props.newBlankType}
      getRpcMethod={props.getRpcMethod}
      getRpcPayload={props.getRpcPayload}
      parseRpcResponse={UpdatedProfileResponse.decode}
      handleContainerTypeUpdate={setBusinessProfile}
      archiveField={props.archiveField}
  />

}